import * as React from "react";
import {
  HeadingXXLarge,
  HeadingXLarge,
  HeadingLarge,
  HeadingMedium,
  HeadingSmall,
  HeadingXSmall,
  ParagraphMedium,
} from "baseui/typography";

import { UL, OL, ArrowedLI } from "../List";
import { DD, DL, DT } from "../DescriptionList";

/* eslint-disable react/prop-types */

const HeadingRenderer = (props) => {
  const Component =
    {
      [1]: HeadingXXLarge,
      [2]: HeadingXLarge,
      [3]: HeadingLarge,
      [4]: HeadingMedium,
      [5]: HeadingSmall,
      [6]: HeadingXSmall,
    }[props.level] ?? "div";
  return <Component {...props} />;
};

const ListRenderer = (props) => {
  // `ordered` and `spread` cause a browser console error, so remove them.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { ordered, spread, ...restProps } = props;
  const Component = ordered ? OL : UL;
  return <Component {...restProps} />;
};

const ParagraphRenderer = ({ children }) => (
  <ParagraphMedium color="mono700">{children}</ParagraphMedium>
);

// Hardcoding all Markdown list items to be "arrowed" for now.
// Hardcoding all Paragraphs to be the same grey as list items for now.
const renderers = {
  heading: HeadingRenderer,
  paragraph: ParagraphRenderer,
  list: ListRenderer,
  listItem: ArrowedLI,
  descriptionList: DL,
  descriptionTerm: DT,
  descriptionDetails: DD,
};

export { renderers };
